import { useNavigate } from 'react-router-dom';

import { RoutesConstants } from '../../../../helpers/routes.helpers';
import { ButtonTypeEnum } from '../../../../types/button.types';
import { Button } from '../../index';

export const ErrorComponent = () => {
  const navigate = useNavigate();

  const handleBackButtonClick = () => {
    navigate(0);
  };

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: '100vh',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: '20%',
          left: '50%',
          transform: 'translateX(-50%)',
        }}
      >
        <div>
          <p style={{ fontSize: '24px', color: '#222222' }}>Ooops something went wrong.</p>
        </div>
        <div style={{ width: '50%', margin: 'auto' }}>
          <Button onClick={handleBackButtonClick} variant={ButtonTypeEnum.primary}>
            Go back
          </Button>
        </div>
      </div>
    </div>
  );
};
